import domReady from '@wordpress/dom-ready';

domReady(() => {
  const links = document.querySelectorAll('.nav-item__link');

  links.forEach((link) => {
    if (link.hostname && link.hostname !== window.location.hostname) {
      link.classList.add('is-external');
    } else {
      link.classList.add('is-internal');
    }
  });
});
